import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from '@/shared/components/ProtectedRoute';
import GuestRoute from '@/shared/components/GuestRoute';
import Index from '@/domains/Index';
import SLAPage from '@/app/legal/SLAPage';
import UserGuidePage from '@/app/legal/user-guide/UserGuidePage';
import LoginPage from '@/app/auth/LoginPage';
import ForgotPasswordPage from '@/app/auth/ForgotPasswordPage';
import ResetPasswordPage from '@/app/auth/ResetPasswordPage';
import VerifyOTPPage from '@/app/auth/VerifyOTPPage';
import { CatchAllRoute } from '@/app/shared/CatchAllRoute';
import ProductsPage from '@/domains/products/pages/ProductsPage';
import UserTerminalsPage from '@/domains/terminals/pages/UserTerminalsPage';
import AddressesPage from '@/domains/addresses/pages/AddressesPage';
import AccountsPage from '@/domains/accounts/pages/AccountsPage';
import AccountDetailsPage from '@/domains/accounts/pages/AccountDetailsPage';
import ServiceLineDetailsPage from '@/domains/service-lines/pages/ServiceLineDetailsPage';
import { ROUTES } from '@/config/routeConfig';
import UsersPage from '@/domains/users/pages/UsersPage';
import DatapoolConsumptionPage from '@/domains/datapool-consumptions/pages/DatapoolConsumptionPage';
import L2VPNCircuitsPage from '@/domains/l2vpns/pages/L2VPNCircuitsPage';
import InvoicesPage from '@/domains/invoices/pages/InvoicesPage';
import CustomerDetailsPage from '@/domains/customers/pages/CustomerDetailsPage';
import CustomerServiceLineDetailsPage from '@/domains/customers/pages/CustomerServiceLineDetailsPage';

/**
 * Platform (Orbius) shell: auth + global `/home/*` navigation for SUPER_ADMIN.
 * Selected when `global-roles` includes SUPER_ADMIN (see `platform-access.ts`).
 */
export function PlatformRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path={ROUTES.LOGIN} element={<GuestRoute><LoginPage /></GuestRoute>} />
      <Route path={ROUTES.FORGOT_PASSWORD} element={<GuestRoute><ForgotPasswordPage /></GuestRoute>} />
      <Route path={ROUTES.RESET_PASSWORD} element={<GuestRoute><ResetPasswordPage /></GuestRoute>} />
      <Route path={ROUTES.VERIFY} element={<GuestRoute><VerifyOTPPage /></GuestRoute>} />
      <Route
        path={ROUTES.ACCOUNTS}
        element={
          <ProtectedRoute>
            <AccountsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.SUBSCRIPTIONS}
        element={
          <ProtectedRoute>
            <ProductsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.TERMINALS}
        element={
          <ProtectedRoute>
            <UserTerminalsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.ADDRESSES}
        element={
          <ProtectedRoute>
            <AddressesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.USERS}
        element={
          <ProtectedRoute>
            <UsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.DATAPOOL_CONSUMPTION}
        element={
          <ProtectedRoute>
            <DatapoolConsumptionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.INVOICES}
        element={
          <ProtectedRoute>
            <InvoicesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.L2VPN_CIRCUITS}
        element={
          <ProtectedRoute>
            <L2VPNCircuitsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.ACCOUNT_DETAILS_TAB.replace(':tabSlug', ':tabSlug?')}
        element={
          <ProtectedRoute>
            <AccountDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.SERVICE_LINE_DETAILS}
        element={
          <ProtectedRoute>
            <ServiceLineDetailsPage mode="tenant" />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CUSTOMER_SERVICE_LINE_DETAILS}
        element={
          <ProtectedRoute>
            <CustomerServiceLineDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CUSTOMER_DETAILS_TAB.replace(':tabSlug', ':tabSlug?')}
        element={
          <ProtectedRoute>
            <CustomerDetailsPage shouldAllowAccountChange={false} />
          </ProtectedRoute>
        }
      />
      <Route path={ROUTES.SLA} element={
        <ProtectedRoute>
          <SLAPage />
        </ProtectedRoute>
      }
      />
      <Route path={ROUTES.USER_GUIDE} element={
        <ProtectedRoute>
          <UserGuidePage />
        </ProtectedRoute>
      }
      />
      <Route path="*" element={<CatchAllRoute />} />
    </Routes>
  );
}
